import { InboxEntryType, RawEmailEntry, RawFileEntry, RawInboxEntry } from '.';

import { PermanentlyDeletedSocketData } from './PermanentlyDeletedSocketData';
import { StaleEntry } from './StaleEntry';

export type RefreshedEmailEntryData = {
  rawEmailEntry: RawEmailEntry;
  rawEmailFileEntry: RawFileEntry;
};

export type RawEntry = RawFileEntry | RefreshedEmailEntryData;
export type RefreshedInboxEntry = {
  rawEntry: RawEntry;
  rawIboxEntry: RawInboxEntry;
};

export type SocketPayload = {
  'project-id': string;
  'user-id': number;
  'inbox-entry-source': InboxEntryType;
  'inbox-entry-source-id': number;
  'inbox-email-id': number;
  'inbox-email-attachment-id': number;
  deleted?: boolean;
  inserted?: boolean;
};

export type SocketData = StaleEntry | PermanentlyDeletedSocketData;

export type UpdatedEmailFiles = {
  [key: number]: RawFileEntry;
};

export type UpdatedEmailEntry = {
  refreshedEmailEntryData: RefreshedEmailEntryData;
  // emailFilesQueue?: UpdatedEmailFiles;
};

export type UpdatedEmailEntries = {
  [key: number]: RefreshedEmailEntryData;
};

export type DeletedEmailEntries = {
  [key: number]: true;
};

export function isRefreshedEmailEntryData(data: RawEntry): data is RefreshedEmailEntryData {
  return typeof data === 'object' && data !== null && data !== undefined && 'rawEmailEntry' in data;
}
